<template>
  <v-dialog v-model="previewDialog" scrollable persistent>
    <v-card :loading="loading" loader-height="2">
      <v-card-title>Preview {{ view.name }}</v-card-title>
      <v-card-text>
        <v-img :src="view.file_name"></v-img>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn small text color="red" v-on="on" @click="closeDialog">
              NO
            </v-btn>
          </template>
          <span>cancel</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Restful from "@/services/RestFul";
//   import moment from "moment";
//   import Utils from "./../../../../mixins/utils";
export default {
  props: {
    previewDialog: Boolean,
    myId: { type: Number, default: 0 },
  },
  // mixins: [Utils],
  data() {
    return {
      loading: false,
      view: { name: null, file_name: null },
    };
  },
  created() {
    this.find();
  },
  methods: {
    find() {
      this.loading = true;
      let self = this;
      console.log(this.myId);
      Restful.subscribers.certificate
        .find(this.myId)
        .then((response) => {
          console.log(response.data);
          this.view.name = response.data.name;
          this.view.file_name = response.data.file_name;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error.response);
          self.snack.color = "error";
          self.snack.text = error.response.data;
          self.loading = false;
        });
    },
    closeDialog() {
      let payload = { id: this.myId, state: false };
      this.$emit("closePreview", payload);
    },
  },
};
</script>
